import React from 'react';
import { Box, Typography, Container, Grid, Divider, IconButton } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useNavigate } from 'react-router-dom';

const footerLinks = {
  Services: ['CCTV Installation', 'AMC & Maintenance', 'Cloud Storage', 'Remote Monitoring', 'Access Control'],
  Products: ['IP Cameras', 'Analog HD Cameras', 'NVR / DVR', 'Accessories', 'All Products'],
  Company: ['About Us', 'Our Team', 'Careers', 'Blog', 'Privacy Policy'],
};

export default function Footer() {
 const navigate = useNavigate(); // navigate function initialize करा

  return (
    <Box sx={{
      background: 'linear-gradient(180deg, #061525, #04101d)',
      borderTop: '1px solid rgba(30,144,212,0.15)',
    }}>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6}>
          {/* Brand */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
              <Box sx={{
                width: 42, height: 42,
                background: 'linear-gradient(135deg, #1e90d4, #0a5a8a)',
                borderRadius: '8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <CameraAltIcon sx={{ color: '#fff', fontSize: 22 }} />
              </Box>
              <Box>
                <Typography sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 900, color: '#e8f0fe', lineHeight: 1 }}>
                  CCTV <span style={{ color: '#1e90d4' }}>PARTNER</span>
                </Typography>
                <Typography sx={{ fontSize: '0.6rem', letterSpacing: '2px', color: '#8fb3d9', textTransform: 'uppercase' }}>
                  Eagle Eye Surveillance
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ color: '#8fb3d9', lineHeight: 1.8, fontSize: '0.9rem', mb: 3, maxWidth: 300 }}>
               most trusted CCTV installation & surveillance system provider. 
              Protecting homes and businesses since 2009.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {[
                { icon: <FacebookIcon />, color: '#1877f2' },
                { icon: <InstagramIcon />, color: '#e1306c' },
                { icon: <YouTubeIcon />, color: '#ff0000' },
                { icon: <WhatsAppIcon />, color: '#25d366' },
              ].map(({ icon, color }, i) => (
                <IconButton
                  key={i}
                  size="small"
                  sx={{
                    background: `${color}15`,
                    border: `1px solid ${color}25`,
                    color: color,
                    '&:hover': { background: `${color}25`, transform: 'translateY(-2px)' },
                    transition: 'all 0.2s',
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <Grid item xs={6} md={2} key={title}>
              <Typography sx={{ color: '#e8f0fe', fontWeight: 600, mb: 2.5, fontSize: '0.9rem' }}>
                {title}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
                {links.map((link) => (
    <Typography
      key={link}
      onClick={() => {
        if (link === 'Privacy Policy') {
          navigate('/privacy-policy');
          window.scrollTo(0, 0); // पेजच्या वरती जाण्यासाठी
        }
      }}
      sx={{
        color: '#8fb3d9', fontSize: '0.85rem', cursor: 'pointer',
        '&:hover': { color: '#1e90d4', pl: 0.5 },
        transition: 'all 0.2s',
      }}
    >
      {link}
    </Typography>
  ))}
              </Box>
            </Grid>
          ))}

          {/* Contact quick info */}
          <Grid item xs={12} md={2}>
            <Typography sx={{ color: '#e8f0fe', fontWeight: 600, mb: 2.5, fontSize: '0.9rem' }}>
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Typography sx={{ color: '#8fb3d9', fontSize: '0.85rem' }}>📞 +91 98765 43210</Typography>
              <Typography sx={{ color: '#8fb3d9', fontSize: '0.85rem' }}>✉️ info@cctvpartner.in</Typography>
              <Typography sx={{ color: '#8fb3d9', fontSize: '0.85rem' }}>📍  Maharashtra</Typography>
              
              <Box sx={{ mt: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Box sx={{ width: 6, height: 6, borderRadius: '50%', background: '#2ecc71', animation: 'blink 2s infinite', '@keyframes blink': { '0%,100%': { opacity: 1 }, '50%': { opacity: 0.3 } } }} />
                  <Typography sx={{ color: '#2ecc71', fontSize: '0.78rem', fontWeight: 600 }}>Available Now</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 5, borderColor: 'rgba(30,144,212,0.1)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ color: '#8fb3d9', fontSize: '0.82rem' }}>
            © {new Date().getFullYear()} CCTV Partner – Eagle Eye Surveillance System. All rights reserved.
          </Typography>
          <Typography sx={{ color: '#8fb3d9', fontSize: '0.82rem' }}>
            kolhapur · 
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
